export const defaultFilterDomainState = {
    filmFilters: {},
    showtimeFilters: {},
    subscriptionFilters: {}
};
